module.exports = __webpack_public_path__ + "img/acte.e89a3709.png";